export default ({
    mainBackgroundColor = '#000',
    highlightColor = '#BA003A',
    liveColor = '#BA003A',
    dropColor = '#C3B244',
    nonCountingScoreColour = '#878787',
} = {}) => {
    const home = {
        backgroundColor: mainBackgroundColor,
        color: '#fff'
    };

    const scoreBox = {
        backgroundColor: '#FFF',
        borderColor: '#000',
        color: nonCountingScoreColour
    }

    const list = {
        backgroundColor: '#EDEDED',
        color: '#000',
        itemOdd: {
            backgroundColor: '#FFF',
            borderColor: '#FFF'
        },
        itemEven: {
            backgroundColor: '#D5D5D5',
            borderColor: '#D5D5D5'
        },
        itemActive: {
            backgroundColor: liveColor,
            borderColor: liveColor,
            color: '#FFF'
        },
        itemNext: {
            borderColor: liveColor
        }
    };

    return {
        home,
        apiError: {
            backgroundColor: '#FF1717',
            color: '#FFF'
        },
        draggable: {
            ...home,
            borderColor: '#fff'
        },
        headerEvent: {
            hamburger: {
                default: {
                    backgroundColor: 'transparent',
                    color: '#FFF'
                },
                active: {
                    backgroundColor: liveColor,
                    color: '#FFF'
                }
            }
        },
        headerCard: {
            backgroundColor: '#C6C6C6',
            color: '#000',
            locationColor: '#878787',
            details: {
                color: '#000',
                scoreColor: '#000'
            }
        },
        headerScores: {
            backgroundColor: '#C6C6C6',
            color: '#000',
            scoreBox,
            scoreBoxHighlight: {
                ...scoreBox,
                color: highlightColor
            },
            scoreBoxDrop: {
                ...scoreBox,
                color: dropColor
            },
            scoreBoxCurrent: {
                ...scoreBox,
                color: '#000'
            },
            laptimeRowOdd: {
                backgroundColor: '#D4D4D4'
            },
            laptimeRowEven: {
                backgroundColor: '#fff'
            }
        },
        listSwitcher: {
            color: '#FFF',
            activeColor: highlightColor
        },
        startList: {
            ...list,
            extra: {
                label: {
                    color: '#878787'
                },
                value: {
                    color: '#000'
                },
                item: {
                    borderColor: '#000'
                }
            },
            extraActive: {
                label: {
                    color: '#FFF'
                },
                value: {
                    color: '#FFF'
                },
                item: {
                    borderColor: '#FFF'
                }
            }
        },
        leaderboard: {
            ...list,
            scores: {
                default: {
                    color: '#000'
                },
                active: {
                    color: '#FFF'
                },
                highlight: {
                    color: highlightColor
                },
                highlightActive: {
                    color: '#FFF'
                },
                nonCounting: {
                    color: nonCountingScoreColour
                },
                extra: {
                    color: '#878787'
                },
                extraActive: {
                    color: '#878787'
                },
                drop: {
                    color: dropColor
                },
                runnersUp: {
                    color: '#7C7C7C'
                }
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/colors.js